<template>
  <a
    :href="link"
    rel="noopener"
    target="_blank"
    class="facebook-link"
    @click="transitionToFacebook">
    <svg
      width="16"
      height="16"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="facebook-icon">
      <g clip-path="url(#clip0)">
        <!--eslint-disable max-len-->
        <path
          d="M9.89433 0.602669L8.37539 0.600006C6.66892 0.600006 5.56611 1.83642 5.56611 3.7501V5.20251H4.03889C3.90692 5.20251 3.80005 5.31943 3.80005 5.46364V7.56801C3.80005 7.71223 3.90704 7.82901 4.03889 7.82901H5.56611V13.139C5.56611 13.2832 5.67298 13.4 5.80495 13.4H7.79755C7.92952 13.4 8.03639 13.2831 8.03639 13.139V7.82901H9.82207C9.95404 7.82901 10.0609 7.71223 10.0609 7.56801L10.0616 5.46364C10.0616 5.3944 10.0364 5.32808 9.9917 5.27908C9.94698 5.23007 9.88605 5.20251 9.82268 5.20251H8.03639V3.97129C8.03639 3.37951 8.16543 3.0791 8.87086 3.0791L9.89409 3.0787C10.0259 3.0787 10.1328 2.96178 10.1328 2.8177V0.863668C10.1328 0.719719 10.0261 0.602936 9.89433 0.602669Z"
          fill="white" />
        <!--eslint-enable max-len-->
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="12.8"
            height="12.8"
            fill="white"
            transform="translate(0.600098 0.600006)" />
        </clipPath>
      </defs>
    </svg>
  </a>
</template>

<script>
import { mapGetters } from 'vuex';
import MobileAppMessagingDriver from 'Root/drivers/MobileAppMessagingDriver';

export default {
  name: 'Facebook',

  data() {
    return {
      link: 'https://www.facebook.com/skycoachgg',
    };
  },

  computed: {
    ...mapGetters(['isPlatformApp']),
  },

  methods: {
    transitionToFacebook(event) {
      if (this.isPlatformApp) {
        event.preventDefault();
        MobileAppMessagingDriver.openUrl(this.link);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .facebook-link {
    --circle-bg-color: #{$color--basic-dark-gray};
    --circle-size: 40px;
    --icon-size: 16px;

    display: flex;
    justify-content: center;
    align-items: center;
    width: var(--circle-size);
    height: var(--circle-size);
    background-color: var(--circle-bg-color);
    border-radius: 50%;
  }

  .facebook-icon {
    width: var(--icon-size);
    height: var(--icon-size);
  }
</style>
